module.exports = __webpack_public_path__ + "img/charles.a6ab27f2.jpg";